'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavData = (_temp = _class = function (_SvgIcon) {
  _inherits(NavData, _SvgIcon);

  function NavData() {
    _classCallCheck(this, NavData);

    return _possibleConstructorReturn(this, (NavData.__proto__ || Object.getPrototypeOf(NavData)).apply(this, arguments));
  }

  _createClass(NavData, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M16.5 2C19.538 2 22 4.462 22 7.5c0 .55-.083 1.08-.233 1.58.237-.05.48-.08.733-.08 1.933 0 3.5 1.567 3.5 3.5S24.433 16 22.5 16H5c-1.657 0-3-1.343-3-3s1.343-3 3-3c.475 0 .918.12 1.317.317C6.12 9.917 6 9.475 6 9c0-1.657 1.343-3 3-3 .794 0 1.51.314 2.047.817C11.384 4.103 13.694 2 16.5 2m0-2c-2.874 0-5.413 1.637-6.667 4.07C9.56 4.024 9.28 4 9 4 6.556 4 4.516 5.763 4.084 8.084 1.764 8.516 0 10.556 0 13c0 2.757 2.243 5 5 5h17.5c3.033 0 5.5-2.467 5.5-5.5 0-2.515-1.697-4.64-4.006-5.294C23.84 3.206 20.537 0 16.5 0z' }),
          _react2['default'].createElement('path', {
            d: 'M20 14.5H8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h12c.276 0 .5.224.5.5s-.224.5-.5.5z',
            opacity: '.4'
          })
        );
      }

      return render;
    }()
  }]);

  return NavData;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 18'
}, _temp);
exports['default'] = NavData;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Nav/NavData.js
// module id = 846
// module chunks = 32